<template>
    <section>
        <div style="background-color: #073b74; border-top: solid 3px #2283e0;">
            <b-container class="bv-example-row mt20" style="padding-bottom: 10px; margin-top: 20px; color: white">
                <b-row>
                    <b-col class="mt20" lg="5" xl="5" sm="11" md="5" style="font-size: 22px; font-weight: bold">
                        <div style="margin-top: 20px">共享航次计划指导专家组工作办公室</div>
                        <div style="margin-top: 5px"></div>
                        <!--<b-img v-bind="mainProps"
                           src="../statics/svp_logo.png"
                           fluid alt="Responsive image"
                           class="mt20"
            ></b-img>-->
                    </b-col>
                    <b-col class="mt20" style="align-content: flex-end" lg="7" xl="7" sm="13" md="7">
                        <p class="footer-right">电话：0592-2880163</p>
                        <p class="footer-right">电子邮箱：shanshanlin@xmu.edu.cn</p>
                        <p class="footer-right"><a href="https://beian.miit.gov.cn" target="_blank"
                                style="color: #fff">闽ICP备2024030083号</a></p>
                        <p class="footer-right">
                            <b-button size="sm"
                                style="padding: 0px; padding-left: 3px; padding-right: 3px; margin-right: 10px"
                                variant="outline-light" @click="directAdmin">管理员登录</b-button>由厦门梯度海洋科技有限公司提供技术支持
                        </p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </section>
</template>

<script>
export default {
    name: 'GlobalFooter',
    props: {},
    data() {
        return {
            date: '',
            mainProps: { blank: false, blankColor: '#777', width: 120, height: 120, class: 'm1' },
        };
    },

    mounted() { },

    unmounted() { },

    created() { },

    methods: {
        directAdmin() {
            window.open('https://admin.norc.com.cn/');
        },
    },
};
</script>

<style scoped>
.footer-right {
    text-align: justify;
    text-justify: inter-ideograph;
    padding: 0px;
    font-size: 15px;
    margin-bottom: 5px;
    text-align: end;
}

.bv-example-row {
    min-height: 20px;
    /* border-top: solid 3px #2283e0; */
}

.shortContainer {
    background-color: #f3f3f3;
}
</style>
